import React from 'react';
import { TableColumn } from 'react-data-table-component';
import { DefaultTable } from 'src/components';
import { IBenefit } from '../../interfaces';

export const BenefitsTable: React.FC = () => {
  /* TODO - Waiting backend services
  const { data, error, loading } = useTypedSelector((state) => state.benefits);
  const { getBenefits } = useActions();

  useEffect(() => {
    getBenefits();
  }, []);
  */

  const columns: TableColumn<IBenefit>[] = [
    {
      name: 'id',
      selector: (row: IBenefit) => row.id,
      sortable: true,
      width: 'max-content',
    },
    {
      name: 'name',
      selector: (row: IBenefit) => row.name || '',
      sortable: true,
    },
  ];

  return <DefaultTable columns={columns} data={[]} noTableHead pagination={false} />;
};
